const loginimages = {
  Login_images: "/Images/Login_images/login.png",
};

export default loginimages;
